var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4403 9.22386H20.7202M15.4403 21.8955H19.6642M15.4403 17.6188L20.7202 17.6716M15.4403 13.4477H18.6082M12.2408 10.2798H6M26 22.9514V8.1679C26 6.05597 24.944 5 22.8321 5H18.6082C16.4963 5 15.4403 6.05597 15.4403 8.1679V22.9514C15.4403 25.0634 16.4963 26.1193 18.6082 26.1193H22.8321C24.944 26.1193 26 25.0634 26 22.9514ZM9.12566 5C7.40443 5 6 6.40443 6 8.1151V21.8004C6 22.2756 6.20063 22.9937 6.44351 23.4055L7.3094 24.8416C8.30201 26.4995 9.93875 26.4995 10.9314 24.8416L11.7973 23.4055C12.0401 22.9937 12.2408 22.2756 12.2408 21.8004V8.1151C12.2408 6.40443 10.8363 5 9.12566 5Z",
    stroke: "current",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeasure);
export default __webpack_public_path__ + "static/media/icon-measure.7255dd315c47a86f754f6a47e2e3e7eb.svg";
export { ForwardRef as ReactComponent };